import { render, staticRenderFns } from "./CreateEmailCampaign.vue?vue&type=template&id=bc46a280&scoped=true&"
import script from "./CreateEmailCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateEmailCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc46a280",
  null
  
)

export default component.exports